module.exports = __webpack_public_path__ + "01_short_gold.ed5852ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/01_short_gold.png
// module id = gRxA
// module chunks = 0